var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    viewBox: "0 0 20 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2859 0.714773C18.8915 0.714773 18.5718 1.03449 18.5718 1.42889V3.57122H16.4294V1.42889C16.4294 1.03449 16.1097 0.714773 15.7153 0.714773C15.3209 0.714773 15.0012 1.03449 15.0012 1.42889V3.57122H8.51003C8.11563 1.23797 5.90448 -0.333792 3.57124 0.0606122C1.238 0.454975 -0.333762 2.66617 0.0606003 4.99941C0.454962 7.33266 2.66615 8.90442 4.99939 8.51002C6.79743 8.20608 8.20609 6.79742 8.50999 4.99941H19.2859C19.6803 4.99941 20 4.6797 20 4.28529V1.42885C20 1.03449 19.6803 0.714773 19.2859 0.714773ZM4.28967 7.14174C2.71209 7.14174 1.43323 5.86287 1.43323 4.28529C1.43323 2.70772 2.71209 1.42885 4.28967 1.42885C5.86724 1.42885 7.1461 2.70772 7.1461 4.28529C7.1461 5.86287 5.86724 7.14174 4.28967 7.14174Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.b9de895b.svg";
export { ForwardRef as ReactComponent };